<template>
  <div class="relative w-10 h-10">
    <div class="absolute inset-0 border-4 border-slate-100 rounded-full"></div>

    <div
      class="absolute inset-0 border-4 border-[#386f99] rounded-full animate-loader-spin border-t-transparent border-l-transparent"
    ></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.loader {
  width: 50px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: radial-gradient(farthest-side, #ffffff 94%, #0000) top/8px 8px
      no-repeat,
    conic-gradient(#0000 30%, #ffffff);
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0);
  mask: radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0);
  animation: l13 1s infinite linear;
}
@keyframes l13 {
  100% {
    transform: rotate(1turn);
  }
}

.animate-loader-spin {
  animation: spin 0.8s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  /* Questo trucco arrotonda le estremità dei bordi */
  border-radius: 50%;
  border-top-color: transparent !important;
  border-left-color: transparent !important;
  stroke-linecap: round;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
